export default function getCoords(elem: HTMLElement): {
  top: number;
  left: number;
  right: number;
  bottom: number;
  centerX: number;
  centerY: number;
  width: number;
  height: number;
} {
  // crossbrowser version
  const box = elem.getBoundingClientRect();

  const { body } = document;
  const docEl = document.documentElement;

  const scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
  const scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;

  const clientTop = docEl.clientTop || body.clientTop || 0;
  const clientLeft = docEl.clientLeft || body.clientLeft || 0;

  const width = box.width;
  const height = box.height;
  const top = Math.round(box.top + scrollTop - clientTop);
  const left = Math.round(box.left + scrollLeft - clientLeft);
  const centerX = Math.round(left + width / 2);
  const centerY = Math.round(top + height / 2);
  const right = left + width;
  const bottom = top + height;

  return { left, top, centerX, centerY, width, height, bottom, right };
}
